import { ErrorType, IConfirmationApiRequest } from '../../shared/types';
import { Confirmation } from '../contracts';
import axios from 'axios';
import CookieHelper from '../../utils/cookieHelper';
import { createAxiosConfig } from '../createAxiosConfig';
import { LogCannon } from '@ace-clublabs/log-cannon';
import StatusCode from 'status-code-enum';
import { ErrorMessageTypes } from '@lib/types';

export const ConfirmationApi =
  (endpoint: string): Confirmation =>
  async (request: IConfirmationApiRequest) => {
    try {
      const { transactionId, email, isTransactionCheck, productType, memcid, productId } = request;
      const scenario = CookieHelper.getCookie('scenario');
      let endPoint =
        endpoint +
        '?transactionId=' +
        transactionId +
        '&productId=' +
        productId +
        '&isTransactionCheck=' +
        isTransactionCheck +
        '&productType=' +
        productType +
        '&memcid=' +
        memcid;
      endPoint += email ? `&email=${email}` : '';
      const { data } = await axios.get(endPoint, createAxiosConfig(scenario, endPoint));
      return Promise.resolve(data);
    } catch (error: any) {
      LogCannon.error('ConfirmationApi error', error);
      if (error.response) {
        const statusCode = error.response.status;
        const errorMessage = error.response.data?.message || error.response.data?.error?.message || error?.message;

        return Promise.reject({
          message: errorMessage,
          type: ErrorType.SYSTEM_ERROR,
        });
      }

      return Promise.reject({
        message: error?.message,
        type: ErrorType.SYSTEM_ERROR,
      });
    }
  };
